import { styled } from "../../../../../../styles";

export const EmptyStateContainer = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  height: "100%",
  paddingBottom: "30%",

  p: {
    fontFamily: "$openSans",
    fontSize: "$text-lg",
    fontWeight: 400,

    color: "$charcoal",
  },
});

export const AccordionTitleButton = styled("a", {
  all: "unset",

  textDecoration: "underline",

  fontSize: "$text-lg",
  lineHeight: "22px",
});
